import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { ServiceJobParser } from "@/models/admin/serviceJob/serviceJob.parser"
import { IServiceJob } from "@/models/admin/serviceJob/serviceJob.types"
import { GetBeFinancialsJobsListQuery } from "@/api/hasura/generated/graphql"

type JobsListRawResponse = GetBeFinancialsJobsListQuery

// Triggers are identified by the (trigger_group, trigger_name) pair in Quartz.
const triggerKey = (group: string, name: string): string => `${group} ${name}`

class ServiceJobsServiceClass {
  getJobs(): QueryResult<IServiceJob[]> {
    return useQuery({
      ...HasuraQueries.serviceJobs.all(),
      useRawResponse: true,
      placeholderData: [],
      parserFn: (data: JobsListRawResponse): IServiceJob[] => {
        const cronByTrigger = new Map<string, string>()
        data.financials_qrtz_cron_triggers.forEach((cron) => {
          cronByTrigger.set(
            triggerKey(cron.trigger_group, cron.trigger_name),
            cron.cron_expression,
          )
        })

        return data.financials_qrtz_triggers.map((trigger) =>
          ServiceJobParser.toDomain({
            sched_name: trigger.sched_name,
            cron_expression:
              cronByTrigger.get(
                triggerKey(trigger.trigger_group, trigger.trigger_name),
              ) ?? null,
          }),
        )
      },
    })
  }
}

export const ServiceJobsService = new ServiceJobsServiceClass()
